import { ErrorHandler, Inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@modules/core';
import { Environment } from '@nx-ng/types';

@Injectable({
  providedIn: 'root',
})
export class ImageUrlService extends ErrorHandler {
  constructor(@Inject(ENVIRONMENT) private env: Environment) {
    super();
  }

  getImageUrl(path: string) {
    return this.env.production
      ? `${this.env.cdnBaseUrl}/app${path}`
      : `${window.location.origin}${path}`;
  }

  getImageSrcSet(srcSet: string) {
    return srcSet
      .split(',')
      .map((url: string) => this.getImageUrl(url.trim()))
      .join(', ');
  }
}
